import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { cn } from '~/lib/utils'
import { Button } from '~/lib/ui/button'
import { useBenefits } from '../BenefitsProvider'
import { useFormatTime } from '~/hooks/useFormatTime'
import SelectStatusIndicator from './SelectStatusIndicator'
import YnsIcon from '~/components/icons/YnsIcon'
import CandidateChangeFormatDialog from './CandidateChangeFormatDialog'

const CalendarIcon = ({ className }) => (
  <YnsIcon name="calendar" className={cn(className)} />
)

export default function SelectCalendlyEventInfo({
  calendlyEvent,
  dashboardCard,
  serviceRequestsPageCard,
  linkColor,
  buttonUrl,
  isResumeReview = false,
}) {
  const { t, locale } = useTranslation()
  const { onCancelClick, select } = useBenefits()
  const formatTime = useFormatTime(locale)

  const { start_time, join_url, reschedule_url, cancel_url } = calendlyEvent
  const formattedStartTime = formatTime(start_time)
  return (
    <div className="flex flex-col gap-2">
      <SelectStatusIndicator Icon={CalendarIcon} color="green">
        {t('service_card.scheduled')}
      </SelectStatusIndicator>
      <SelectStatusIndicator Icon={CalendarIcon} color="green" filled fullWidth>
        {formattedStartTime}
      </SelectStatusIndicator>
      <a
        href={buttonUrl}
        className={cn('text-link', dashboardCard ? 'flex-grow' : '')}
      >
        <Button
          variant={select ? 'outline' : 'coachcta'}
          className={cn('w-full')}
        >
          {t('service_card.view_details')}
        </Button>
      </a>
      <a
        href={join_url}
        target="_blank"
        rel="noopener noreferrer"
        className={cn('text-link', dashboardCard ? 'flex-grow' : '')}
      >
        <Button
          variant={select ? 'outline' : 'coachcta'}
          className={cn('w-full')}
        >
          {t('service_card.join_meeting')}
          <YnsIcon name="video" className="ml-2" />
        </Button>
      </a>
      <a
        href={reschedule_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onCancelClick()}
        className={cn(linkColor, 'text-link', 'self-center hover:!underline')}
      >
        {t('service_card.reschedule')}
      </a>
      <a
        href={cancel_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onCancelClick()}
        className={cn(linkColor, 'text-link', 'self-center hover:!underline')}
      >
        {t('service_card.cancel')}
      </a>
      {isResumeReview && !serviceRequestsPageCard && !dashboardCard && (
        <CandidateChangeFormatDialog />
      )}
    </div>
  )
}
